import React from 'react';
import styled from 'styled-components';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { MatchStrength } from 'talent_matching/types';

const MatchIndicators = styled.div<{ filledCount: number; color: string }>`
  display: flex;
  flex-direction: row;
  gap: 4px;

  :nth-child(-n + ${(props) => props.filledCount}) {
    background-color: ${(props) => props.color};
  }
`;

const MatchIndicator = styled.div`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background-color: ${FullPalette.GREY_600};
`;

const FillColorMap = {
  strong_match: FullPalette.GREEN_700,
  good_match: FullPalette.GREEN_600,
  partial_match: FullPalette.GREY_900,
  limited_match: FullPalette.EVERGREEN_E300,
};

const FillCountMap = {
  strong_match: 4,
  good_match: 3,
  partial_match: 2,
  limited_match: 1,
};

const StrengthIndicator = ({
  matchStrength,
}: {
  matchStrength: MatchStrength;
}) => {
  const color =
    FillColorMap[matchStrength as keyof typeof FillColorMap] ||
    FillColorMap.limited_match;

  const filledCount =
    FillCountMap[matchStrength as keyof typeof FillCountMap] ||
    FillCountMap.limited_match;

  return (
    <MatchIndicators filledCount={filledCount} color={color}>
      <MatchIndicator />
      <MatchIndicator />
      <MatchIndicator />
      <MatchIndicator />
    </MatchIndicators>
  );
};

export default StrengthIndicator;
